export type PrometheusValkeyCommandsPerSecStatsBackendApiProps = {
    created: number;
    commands_per_sec: number;
};

export default class PrometheusValkeyCommandsPerSecStats {
    readonly created: number;
    readonly commandsPerSec: number;

    constructor(props: PrometheusValkeyCommandsPerSecStatsBackendApiProps) {
        this.created = props.created;
        this.commandsPerSec = props.commands_per_sec;
    }
}
